import { type BaseApiContract } from "shared/api/BaseApiContract";
import { HttpMethod } from "shared/api/http";
import { type PaginatedResults } from "shared/api/types/pagination";
import { type SocietyParamsInput } from "shared/api/types/society/[societyId]";
import { type SocietyChoicesQuestionNameBodyInput } from "shared/api/types/society/[societyId]/choices/index";
import {
  type SocietyCustomQuestionDto,
  type SocietyCustomQuestionView,
} from "shared/mappers/database/society-custom-choices/societyCustomQuestion";
export const getSocietyChoicesContract: BaseApiContract<
  SocietyParamsInput,
  undefined,
  PaginatedResults<SocietyCustomQuestionDto>
> = {
  method: HttpMethod.GET,
  apiRoute: "/api/v1/society/[societyId]/choices",
  paramsType: {} as SocietyParamsInput,
  responseType: {} as PaginatedResults<SocietyCustomQuestionDto>,
};
export const postSocietyChoicesContract: BaseApiContract<
  SocietyParamsInput,
  SocietyChoicesQuestionNameBodyInput,
  SocietyCustomQuestionView
> = {
  method: HttpMethod.POST,
  apiRoute: "/api/v1/society/[societyId]/choices",
  paramsType: {} as SocietyParamsInput,
  bodyType: {} as SocietyChoicesQuestionNameBodyInput,
  responseType: {} as SocietyCustomQuestionView,
};
